import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ServicesComponent } from './pages/services/services.component';
import { ProductsComponent } from './pages/products/products.component';
import { CertificatesComponent } from './pages/certificates/certificates.component';
import { ContactComponent } from './pages/contact/contact.component';

import { AdminLoginComponent } from './pages/admin/admin-login/admin-login.component';
import { AdminDashboardComponent } from './pages/admin/admin-dashboard/admin-dashboard.component';
import { AdminProductsComponent } from './pages/admin/admin-products/admin-products.component';
import { AdminCertificatesComponent } from './pages/admin/admin-certificates/admin-certificates.component';
import { AdminContactRequestsComponent } from './pages/admin/admin-contact-requests/admin-contact-requests.component';

import { AdminHomeComponent } from './pages/admin/admin-home/admin-home.component';
import { AdminAboutComponent } from './pages/admin/admin-about/admin-about.component';
import { AdminServicesComponent } from './pages/admin/admin-services/admin-services.component';
import { AdminSocialLinksComponent } from './pages/admin/admin-social-links/admin-social-links.component';
import { AdminAuthGuard } from './core/guard/admin-auth.guard';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'products', component: ProductsComponent },
  { path: 'certificates', component: CertificatesComponent },
    { path: 'contact', component: ContactComponent },


    { path: 'admin/login', component: AdminLoginComponent },
    { path: 'admin/dashboard', component: AdminDashboardComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/home', component: AdminHomeComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/about', component: AdminAboutComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/services', component: AdminServicesComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/products', component: AdminProductsComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/certificates', component: AdminCertificatesComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/contact-requests', component: AdminContactRequestsComponent, canActivate: [AdminAuthGuard] },
    { path: 'admin/social-links', component: AdminSocialLinksComponent, canActivate: [AdminAuthGuard] },

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
